import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";

import ReactEcharts from "echarts-for-react";
import moment from "moment";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { isMobile } from "react-device-detect";

import $ from "jquery";

import axios from "@app/lib/axios";
import * as Constant from "@app/Constant.js";
import * as util from "@app/lib/utility";

import "./style.css";

import ReportPage from "./ReportPage";
import { toast } from "@app/../node_modules/react-toastify/dist/index";

const elementPageToPrint = "pageToPrint";
const classUseGrade = [
    { id: 1, name: "최우수", colorClass: "#00c3e0", colorSpecial: "#4dd5e9", min: 30, max: null },
    { id: 2, name: "우수", colorClass: "#8147cf", colorSpecial: "#a77fdd", min: 18, max: 29 },
    { id: 3, name: "보통", colorClass: "#41c159", colorSpecial: "#7ad48b", min: 13, max: 17 },
    { id: 4, name: "부족", colorClass: "#ffc000", colorSpecial: "#ffd34d", min: 6, max: 12 },
    { id: 5, name: "미흡", colorClass: "#e25b4d", colorSpecial: "#eb8d83", min: 0, max: 5 },
];
const homeCategorizedCategory = [
    { name: "젤링학습", categories: [0] },
    { name: "액티비티", categories: [13, 14, 15, 19, 34] },
    { name: "리더스", categories: [17, 20, 21] },
    { name: "레벨 UP", categories: [857] },
];
const SelectMonth = ({ onSelectedMonthChange }) => {
    const [selectedYear, setSelectedYear] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(false);
    // 이전년도 리포트 제공 제한 기간(4월말까지)
    const viewEndMonth = 4;
    const schoolYearStartMonth = 3;
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
    const showLastYear = currentMonth < schoolYearStartMonth || currentMonth <= viewEndMonth;
    let showLast2Year = false;
    const months = [];
    const years = [];
    if (showLastYear) {
        if (showLast2Year || (currentMonth >= schoolYearStartMonth && currentMonth <= viewEndMonth)) {
            showLast2Year = true;
            years.push(currentYear - 2);
        }
        years.push(currentYear - 1);
    }
    years.push(currentYear);
    if (showLastYear) {
        if (selectedYear == currentYear) {
            for (let i = 1; i <= currentMonth; i++) {
                months.push(i);
            }
        } else if (showLast2Year && currentYear - 1 == selectedYear) {
            for (let i = 1; i <= 12; i++) {
                months.push(i);
            }
        } else {
            for (let i = schoolYearStartMonth; i <= 12; i++) {
                months.push(i);
            }
        }
    } else {
        for (let i = 1; i <= currentMonth; i++) {
            months.push(i);
        }
    }

    useEffect(() => {
        if (!selectedYear && !selectedMonth) {
            const now = new Date();
            let newSelectedYear = now.getFullYear();
            let newSelectedMonth = now.getMonth();
            if(newSelectedMonth == 0) {  // 1월인 경우 전년도로 수정
                newSelectedMonth = 12;
                newSelectedYear -= 1;
            }
            setSelectedYear(newSelectedYear);
            setSelectedMonth(newSelectedMonth); // 금년도 지난달 기본 선택

            onSelectedMonthChange(newSelectedYear, newSelectedMonth);
        }
        return () => {};
    }, []);

    const onChange = (type, value) => {
        if (type == "year") {
            setSelectedYear(value);
            const currentYear = new Date().getFullYear();
            const currentMonth = new Date().getMonth() + 1;
            if (value < currentYear) {
                setSelectedMonth(3);
            } else {
                setSelectedMonth(currentMonth);
            }
        } else if (type == "month") {
            setSelectedMonth(value);
        }
    };

    return (
        <div className="row">
            <div className="col-4 pr-1">
                <select className="form-control form-control-sm" value={selectedYear} onChange={(e) => onChange("year", e.target.value)}>
                    {years.map((y) => (
                        <option key={`year-${y}`} value={y}>
                            {y}년
                        </option>
                    ))}
                </select>
            </div>
            <div className="col-4 pl-1">
                <select className="form-control form-control-sm" value={selectedMonth} onChange={(e) => onChange("month", e.target.value)}>
                    {months.map((m) => (
                        <option key={`month-${m}`} value={m}>
                            {m}월
                        </option>
                    ))}
                </select>
            </div>
            <div className="col-3 pl-0">
                <button type="button" className="btn btn-sm btn-primary" onClick={() => onSelectedMonthChange(selectedYear, selectedMonth)}>
                    <span>확인</span>
                </button>
            </div>
        </div>
    );
};
const ButtonArea = ({ isWorking, onDownload, onPrint }) => {
    useEffect(() => {
        return () => {};
    }, [isWorking]);
    const history = useHistory();
    const onClose = () => {
        if (isMobile) {
            history.goBack();
        } else {
            window.close();
        }
    };
    return (
        <div className="row">
            <div className="col">
                {!isMobile && (
                    <>
                        <button type="button" className="btn btn btn-sm btn-outline-secondary float-right" style={{ width: "100px" }} onClick={onPrint} disabled={isWorking}>
                            {isWorking && <span className="fa fa-spinner" style={{ animation: "1s spin linear infinite" }}></span>}
                            {!isWorking && (
                                <span>
                                    <i className="fas fa-print mr-1"></i>출력
                                </span>
                            )}
                        </button>
                        <button type="button" className="btn btn btn-sm btn-outline-secondary float-right mr-2" style={{ width: "100px" }} onClick={onDownload} disabled={isWorking}>
                            {isWorking && <span className="fa fa-spinner" style={{ animation: "1s spin linear infinite" }}></span>}
                            {!isWorking && (
                                <span>
                                    <i className="fas fa-file-pdf mr-1"></i>다운로드
                                </span>
                            )}
                        </button>
                    </>
                )}
                {isMobile && (
                    <>
                        <button type="button" className="btn btn btn-sm btn-outline-secondary float-right mr-2" style={{ width: "100px" }} onClick={onClose} disabled={isWorking}>
                            {isWorking && <span className="fa fa-spinner" style={{ animation: "1s spin linear infinite" }}></span>}
                            {!isWorking && (
                                <span>
                                    <i className="fas fa-window-close mr-1"></i>돌아가기
                                </span>
                            )}
                        </button>
                        {/* <button type="button" className="btn btn btn-sm btn-outline-secondary float-right mr-2" style={{ width: "100px" }} onClick={onDownload} disabled={isWorking}>
                            {isWorking && <span className="fa fa-spinner" style={{ animation: "1s spin linear infinite" }}></span>}
                            {!isWorking && (
                                <span>
                                    <i className="fas fa-file-pdf mr-1"></i>다운로드
                                </span>
                            )}
                        </button> */}
                    </>
                )}
            </div>
        </div>
    );
};
const PageHeader = ({ isWorking, nurseryName, onDownload, onPrint, onSelectedMonthChange }) => {
    useEffect(() => {
        return () => {};
    }, [nurseryName]);
    return (
        <div className="row">
            <div className="col-4">
                <SelectMonth onSelectedMonthChange={onSelectedMonthChange} />
            </div>
            <div className="col-4 text-center h4">{nurseryName}</div>
            <div className="col-4 float-right">
                <ButtonArea isWorking={isWorking} onDownload={onDownload} onPrint={onPrint} />
            </div>
        </div>
    );
};

const StatJelliingReport = (props) => {
    const [loadingData, setLoadingData] = useState(true);
    const [isWorking, setWorkingStatus] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(false);
    const [periodInfo, setPeriodInfo] = useState(false);
    const [nurseryUniqInfo, setNurseryUniqInfo] = useState(false);
    const [classList, setClassList] = useState(false);
    const [classSummary, setClassSummary] = useState(false);
    const [homeSummary, setHomeSummary] = useState(false);
    const { branchId, nurseryUniqId } = useParams();
    const printRef = useRef(null);
    useEffect(() => {
        if (selectedMonth) {
            getStat(branchId, nurseryUniqId, selectedMonth.year, selectedMonth.month);
        }
        return () => {};
    }, [selectedMonth]);
    const getStat = (branchId, nurseryUniqId, year, month) => {
        setLoadingData(true);
        setPeriodInfo(false);
        setNurseryUniqInfo(false);
        setClassList(false);
        setHomeSummary(false);
        axios({
            method: "POST",
            url: `/api/jelliing_stat/report/${nurseryUniqId}`,
            data: {
                branchId,
                selectedYear: year,
                selectedMonth: month,
            },
        })
            .then((result) => {
                if (result.data && result.data.code === 200) {
                    const stat = result.data;
                    const classList = stat.classList;
                    const weekList = [];
                    const classSummary = { total: 0, avgWeek: 0.0, textGrade: "", textGradeDesc: "", gradeClass: [] };
                    const homeSummary = { total: 0, use: 0, usePercent: 0, top: [] };
                    const startDateClass = moment(stat.periodInfo.startDateClass);
                    const endDateClass = moment(stat.periodInfo.endDateClass);
                    let weekStartDay = startDateClass.clone();
                    for (let i = 0; i < 6; i++) {
                        if (weekStartDay > endDateClass) {
                            break;
                        }
                        weekList.push({ first: weekStartDay.clone(), last: weekStartDay.weekday(7).clone() });
                        weekStartDay.add(1, "d");
                    }
                    homeCategorizedCategory.forEach((cat) => {
                        cat.categoryNames = cat.categories.map((categoryId) => {
                            const catServer = stat.categories.library.find((l) => l.id == categoryId);
                            if(catServer) return catServer.name;
                            else return null;
                        }).join(',');
                    });

                    if (classList && classList.length > 0) {
                        classList.forEach((c) => {
                            c.stat = { class: { total: 0, playCountClassSumTotal: 0, playCountSpecialSumTotal: 0, avgWeek: 0.0, grade: "미흡", weekly: [] }, home: { total: 0, categories: [] } };
                            c.childUse = 0;
                            const statClass = stat.statClass.filter((s) => c.id == s.classId);
                            if (statClass && weekList.length > 0) {
                                for (let i = 0; i < weekList.length; i++) {
                                    const weeklyStat = statClass.filter((d) => moment(d.statDate).isBetween(weekList[i].first, weekList[i].last, undefined, "[]"));
                                    const classWeek = { first: weekList[i].first.format("M/D"), last: weekList[i].last.format("M/D"), playCountClassSum: 0, playCountSpecialSum: 0 };
                                    if (weeklyStat) {
                                        classWeek.playCountClassSum = weeklyStat.reduce((acc, current) => acc + current.playCountClassSum, 0);
                                        classWeek.playCountSpecialSum = weeklyStat.reduce((acc, current) => acc + current.playCountSpecialSum, 0);
                                        c.stat.class.playCountClassSumTotal += classWeek.playCountClassSum;
                                        c.stat.class.playCountSpecialSumTotal += classWeek.playCountSpecialSum;
                                    }
                                    c.stat.class.weekly.push(classWeek);
                                }
                                c.stat.class.total = c.stat.class.playCountClassSumTotal + c.stat.class.playCountSpecialSumTotal;
                                c.stat.class.avgWeek = (c.stat.class.total / weekList.length).toFixed(1);
                                for (let i = 0; i < classUseGrade.length; i++) {
                                    if (c.stat.class.total >= classUseGrade[i].min) {
                                        c.stat.class.grade = classUseGrade[i];
                                        const g = classSummary.gradeClass.find((g) => g.id == c.stat.class.grade.id);
                                        if (g) {
                                            g.classes.push(c.name);
                                        } else {
                                            classSummary.gradeClass.push({ id: c.stat.class.grade.id, name: c.stat.class.grade.name, classes: [c.name] });
                                        }
                                        break;
                                    }
                                }
                                classSummary.total += c.stat.class.total;
                            }

                            const statHome = stat.statHome.find((s) => c.id == s.id);
                            if (statHome) {
                                homeCategorizedCategory.forEach((cat) => {
                                    const category = { name: cat.name, playCountSum: 0 };
                                    category.playCountSum = (statHome.home_class_play || 0);
                                    cat.categories.forEach((categoryId) => category.playCountSum += (statHome[`lib_${categoryId}_play`] || 0));
                                    category.categoryNames = cat.categories.map((categoryId) => {
                                        const catServer = stat.categories.library.find((l) => l.id == categoryId);
                                        if(catServer) return catServer.name;
                                        else return null;
                                    }).join(',');
                                    c.stat.home.categories.push(category);
                                    c.stat.home.total += category.playCountSum;
                                });
                            }
                            homeSummary.total += c.childJoin;
                            const childs = stat.statChild ? stat.statChild.filter((s) => c.id == s.classId) : null;
                            if (childs) {
                                childs.forEach((child) => (child.className = c.name));
                                c.childUse = childs.length;
                                homeSummary.use += childs.length;
                            }
                        });
                        classSummary.avgWeek = (classSummary.total / classList.length / weekList.length).toFixed(1);
                        if (classSummary.avgWeek >= 3) {
                            if (classSummary.avgWeek >= 5) {
                                classSummary.textGrade = "우수한";
                            } else {
                                classSummary.textGrade = "보통의";
                            }
                            classSummary.textGradeDesc = "유지하고";
                        } else {
                            classSummary.textGrade = "부족한";
                            classSummary.textGradeDesc = "보여주고";
                        }
                        classSummary.gradeClass.sort((a, b) => a.id - b.id);
                    }
                    if (stat.periodInfo) {
                        stat.periodInfo.startDate = moment(stat.periodInfo.startDate).format("M월 D일");
                        stat.periodInfo.endDate = moment(stat.periodInfo.endDate).format("M월 D일");
                    }
                    if (stat.statChild) {
                        for (let i = 0; i < stat.statChild.length; i++) {
                            if (i >= 5) {
                                break;
                            }
                            const child = homeSummary.top.find((c) => c.classId == stat.statChild[i].classId);
                            if (child) {
                                child.childs.push(stat.statChild[i].name);
                            } else {
                                homeSummary.top.push({ classId: stat.statChild[i].classId, name: stat.statChild[i].className, childs: [stat.statChild[i].name] });
                            }
                        }
                    }
                    homeSummary.usePercent = homeSummary.total > 0 ? Math.floor((homeSummary.use / homeSummary.total) * 100) : 0;
                    setPeriodInfo(stat.periodInfo);
                    setNurseryUniqInfo(stat.nurseryUniqInfo);
                    setClassList(classList);
                    setClassSummary(classSummary);
                    setHomeSummary(homeSummary);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");

                setLoadingData(false);
            });
    };
    const onSelectedMonthChange = (year, month) => {
        if (!selectedMonth || selectedMonth.year != year || selectedMonth.month != month) {
            const newSelectedMonth = { year, month };
            setSelectedMonth(newSelectedMonth);
        }
    };

    const handlePrint = () => {
        pageToPdf(true);
    };
    const handleDownload = () => {
        pageToPdf(false);
    };
    const pageToPdf = (isPrint = false) => {
        setWorkingStatus(true);
        const element = document.getElementById(elementPageToPrint);
        const canvasOptions = { scale: 2 };
        html2canvas(element, canvasOptions).then((canvas) => {
            var downloadFileName = `${selectedMonth ? `${nurseryUniqInfo ? nurseryUniqInfo.name : "-"}-${selectedMonth.year}-${selectedMonth.month}.pdf` : ""}`;
            var imgData = canvas.toDataURL("image/jpeg");

            var pageWidth = 210; //가로 길이 a4 기준
            var pageHeight = pageWidth * 1.414; //출력 페이지 세로길이
            var imgWidth = pageWidth;

            var imgHeight = (canvas.height * imgWidth) / canvas.width;
            var heightLeft = imgHeight;

            var pdf = new jsPDF("p", "mm", "a4");
            var position = 0;

            pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            // 여러 페이지 출력
            while (heightLeft >= 20) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            if (isPrint) {
                var blob = pdf.output("blob");
                printPreview(blob);
            } else {
                pdf.save(downloadFileName);
            }
            setWorkingStatus(false);
        });
    };
    const printPreview = (blob, type = "application/pdf") => {
        const blobURL = URL.createObjectURL(blob);
        var options = "top=10, left=10, width=800, height=600, status=no, menubar=no, toolbar=no, resizable=no";
        const theWindow = window.open(blobURL, "리포트 출력", options);
        const theDoc = theWindow.document;
        const theScript = document.createElement("script");
        function injectThis() {
            window.print();
        }
        theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
        theDoc.body.appendChild(theScript);
    };

    return (
        <div className="stat-report-main">
            <div className="row stat-report-header pt-2 pb-1 pl-2 pr-2">
                <div className="col">
                    <PageHeader
                        isWorking={isWorking}
                        nurseryName={nurseryUniqInfo ? nurseryUniqInfo.name : "-"}
                        selectedMonth={selectedMonth}
                        onSelectedMonthChange={onSelectedMonthChange}
                        onDownload={handleDownload}
                        onPrint={handlePrint}
                    />
                </div>
            </div>
            {loadingData ? (
                <div className="page-loading">
                    <div className="h4 align-items-center">리포트를 생성하는 중입니다...</div>
                    <div className="progress">
                        <div
                            className="progress-bar progress-bar-striped progress-bar-animated"
                            role="progressbar"
                            aria-valuenow="100"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: "100%" }}
                        ></div>
                    </div>
                </div>
            ) : (
                <ReportPage
                    ref={printRef}
                    selectedMonth={selectedMonth}
                    periodInfo={periodInfo}
                    nurseryUniqInfo={nurseryUniqInfo}
                    classList={classList}
                    classSummary={classSummary}
                    homeSummary={homeSummary}
                    homeCategorizedCategory={homeCategorizedCategory}
                    classUseGrade={classUseGrade}
                />
            )}
        </div>
    );
};

export default StatJelliingReport;
